// Handle nav tabs behavior

const $navTabs = $('[data-toggle="tab"]');

// On document ready, if the URL anchor corresponds to a nav tab, then select that tab
$(function() {
  const anchor = window.location.hash.replace('#', '');
  const $selectedTab = $navTabs.filter('[id="' + anchor + '"]');
  $selectedTab.click();
});